module.exports = __webpack_public_path__ + "static/media/fruits_50.25538a58.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_50.csv
// module id = 718
// module chunks = 0